import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'react-picky/dist/picky.css';
import { Redirect, withRouter } from 'react-router-dom';
import { clearAlerts } from '../../../../actions/alertsActions';
import PageHeader from '../../../common/PageHeader';
import checkRoles from '../../../common/roleChecker/RoleChecker';
import escalationSchemaMessages from '../../../../intl/admin/escalationSchemaMessages';
import commonMessages from '../../../../intl/common/commonMessages';
import {
    countryGroups,
    getCurrentFormTypes,
    getInternalFormTypes,
} from '../../../../constants/Utils';
import formTypeMessages from '../../../../intl/common/formTypeMessages';
import ListEscalationSchemaTable from './ListEscalationSchemaTable';
import formCountryMessages from '../../../../intl/common/countryGroupMessages';
import {getAdminEscalationSchemaPath} from '../../../../routes/pathResolver';


class ListEscalationSchemaPage extends Component {
    constructor(props) {
        super(props);
        const { intl, domain } = props;
        const internalFormTypesOptions = (getInternalFormTypes(props.domain) || {}).map(formType => ({
            value: formType,
            label: (formTypeMessages[formType] ? intl.formatMessage(formTypeMessages[formType]) : formType) + ' (Internal)'
        }));

        const formTypeOptions = (getCurrentFormTypes(props.domain) || {}).map(formType => ({
            value: formType,
            label: formTypeMessages[formType] ? intl.formatMessage(formTypeMessages[formType]) : formType
        }));

        const allFormTypesOptions = [...formTypeOptions, ...internalFormTypesOptions];

        this.state = {
            ratchet: false,
            escalationSchema: '',
            columnLibrary: [
                {
                    id: 'formType',
                    accessor: row => row.formType,
                    message: escalationSchemaMessages.TABLE_FORMTYPE,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            {allFormTypesOptions.map((item, index) =>
                                <option key={index} value={item.value}>
                                    {item.label}
                                </option>)
                            }
                        </select>
                    ),
                    Cell: e => <div>{this.translateFormType(e.value, intl)}</div>
                },
                {
                    id: 'ticketType',
                    accessor: row => row.ticketType,
                    message: escalationSchemaMessages.TICKET_TYPE,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            {['dealer', 'internal'].map((key, index) =>
                                <option key={index} value={key}>
                                    {key}
                                </option>)
                            }
                        </select>
                    ),
                },
                {
                    id: 'escalationSolutionGroups',
                    accessor: row => this.formatEscalationSolutionGroupsLabel(row.escalationSolutionGroups),
                    message: escalationSchemaMessages.TABLE_ESCALATION_SOLUTION_GROUPS,
                    sortable: false,
                },
                {
                    id: 'group',
                    accessor: row => this.formatCountryLabel(row.groups, intl),
                    message: escalationSchemaMessages.TABLE_COUNTRIES,
                    Filter: ({ filter, onChange }) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: '100%', border: '1px solid #999999' }}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            {Object.keys(countryGroups).map((key, index) =>
                                <option key={index} value={key}>
                                    {formCountryMessages[key] ? intl.formatMessage(formCountryMessages[key]) : key}
                                </option>)}
                        </select>
                    ),
                },
            ],
        };
    }

    translateFormType = (formType, intl) => {
        return formTypeMessages[formType] ? intl.formatMessage(formTypeMessages[formType]) : formType;
    }

    formatCountryLabel = (value, intl) => {
        let result = '';
        if (value) {
            value.map(country => result += intl.formatMessage(formCountryMessages[country]) + ', ')
        }
        return result.replace(/,\s$/, '');
    };

    formatEscalationSolutionGroupsLabel = (value) => {
        let result = '';
        if (value) {
            value.map(sg => result += sg.name + ', ')
        }
        return result.replace(/,\s$/, '');
    };

    componentDidMount() {
        //this.props.clearAlerts();
    }

    handleEditClick = ({ id }) => {
        this.setState({ ratchet: true, escalationSchema: id});
    };

    render() {
        const { filter, domain } = this.props;
        const { columnLibrary, escalationSchema } = this.state;


        if (this.state.ratchet) {
            return <Redirect to={`${getAdminEscalationSchemaPath(this.props.domain)}/edit/${escalationSchema}`}/>;
        }
        return (
            <div className="container-fluid">
                <PageHeader title={
                    <FormattedMessage id="admin.escalationSchema.listTitle"
                                      defaultMessage="Multi-level Escalation Schema - {domain} - Escalation Schema List"
                                      values={{ domain: <FormattedMessage {...formTypeMessages[domain]} /> }} />
                } />
                <ListEscalationSchemaTable
                    columns={columnLibrary}
                    handleEditClick={this.handleEditClick}
                    handleDeleteClick={this.handleDeleteClick}
                    filter={filter}
                    domain={domain}/>
            </div>
        );
    }
}

ListEscalationSchemaPage.propTypes = {
    clearAlerts: PropTypes.func.isRequired,
};

const mapStateToPropos = state => ({});

export default checkRoles(withRouter(connect(mapStateToPropos, {
    clearAlerts,
})(injectIntl(ListEscalationSchemaPage))), ['AS_POWER_USER']);
